module.exports = __webpack_public_path__ + "img/title.baf77c4c.png";